import React from 'react';
import { Button} from 'antd-mobile';
import defaultImg from './default.png'

class carLeaseGuide extends React.Component {
    constructor(...args) {
        super(...args);
        this.state = {
        };
    }

    render() {
        
        return (
            <div className="carLeaseGuideBox" style={{minHeight: '100vh', background: '#f3f4f5'}}>
                <img src={defaultImg} style={{width: '100%'}}/>
            </div>
        );
    }
}
export default carLeaseGuide;


// WEBPACK FOOTER //
// ./src/carLeaseGuide/index/index.js